import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // detailed response model
  allowedPaymentMethods: [],
  availablePaymentMethods: [],
  amount: 0,
  billingAddress: {},
  // Accumulated billing-address overrides returned from MFE hooks
  // (onInitialised / onMethodSelecting / onMethodSelected). These are
  // authoritative and are re-applied on top of the card form values at
  // authorization time so tenant overrides are not lost. See OPP hooks contract.
  hookBillingAddressOverride: {},
  culture: 'en-GB',
  currency: 'GBP',
  defaultPaymentMethod: null,
  expiryDate: null,
  failureUrl: null,
  id: null,
  directDebit: {
    schedules: [],
  },
  is3dsRequired: true,
  isUserAuthenticated: false,
  hideAcceptedCards: false,
  maxAmount: 0,
  minAmount: 0,
  numberOfPassengers: 0,
  tenantId: null,
  timeoutUrl: null,
  successUrl: null,
  returnUrl: null,

  // additional data
  // need to figure out how if we can get rid of them
  overrideAmount: 0,
  directDebitDate: null,
  tenantPaymentMethods: [],
  currentPaymentPlan: {
    amount: 0,
    count: 0,
  },
  displayedComponents: [],
  googlePay: {
    merchantId: null,
    merchantName: null,
    gateway: null,
    gatewayMerchantId: null,
  },
  customPaymentMethods: [],
  recaptcha: {
    action: '',
    isEnabled: false
  },
  // Evervault card form flag, sent by /details (same level as isPciEnabled)
  isEvervaultEnabled: false,
  // Optional per-transaction Evervault ids; fall back to config when absent
  evervault: {
    teamId: null,
    appId: null,
  },
}

const transactionDetailsSlice = createSlice({
  name: 'transactionDetails',
  initialState,
  reducers: {
    transactionDetailsUpdateAction: () => {},
    transactionDetailsUpdate: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    // Accumulate (compose) billing-address overrides coming from MFE hooks.
    // Later hook overrides win over earlier ones on a per-field basis.
    hookBillingAddressOverrideUpdate: (state, { payload }) => ({
      ...state,
      hookBillingAddressOverride: {
        ...state.hookBillingAddressOverride,
        ...payload,
      },
    }),
    transactionDetailsClear: () => initialState,
  },
})

export const {
  transactionDetailsUpdateAction,
  transactionDetailsUpdate,
  hookBillingAddressOverrideUpdate,
  transactionDetailsClear,
} = transactionDetailsSlice.actions

export const transactionDetailsSelector = state => state.transactionDetails

export default transactionDetailsSlice.reducer
